import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import Layout from "./components/layout/Layout";
import HomePage from "./pages/HomePage";
import QuiSommesNousPage from "./pages/QuiSommesNousPage";
import GroupePage from "./pages/GroupePage";
import NotreOffrePage from "./pages/NotreOffrePage";
import ContactPage from "./pages/ContactPage";
import MentionsLegalesPage from "./pages/MentionsLegalesPage";
import ConfidentialitePage from "./pages/ConfidentialitePage";
import ServiceLandingPage from "./pages/ServiceLandingPage";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/qui-sommes-nous" element={<QuiSommesNousPage />} />
              <Route path="/groupe" element={<GroupePage />} />
              <Route path="/notre-offre" element={<NotreOffrePage />} />
              <Route
                path="/team-building"
                element={<ServiceLandingPage slug="team-building" />}
              />
              <Route
                path="/afterwork"
                element={<ServiceLandingPage slug="afterwork" />}
              />
              <Route
                path="/seminaire-entreprise"
                element={<ServiceLandingPage slug="seminaire-entreprise" />}
              />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
              <Route path="/confidentialite" element={<ConfidentialitePage />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
